import { render, staticRenderFns } from "./device.vue?vue&type=template&id=5a042db8&scoped=true&"
import script from "./device.vue?vue&type=script&lang=js&"
export * from "./device.vue?vue&type=script&lang=js&"
import style0 from "./device.vue?vue&type=style&index=0&id=5a042db8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a042db8",
  null
  
)

export default component.exports